import { useEffect, useState } from "react";
import Modal from "components/common/Modal";
import Alert from "components/common/Alert";
import CurrencyTable from "./CurrencyTable";
import CurrencyForm from "./CurrencyForm";
import { useCurrency } from "./hooks/useCurrency";

export default function CurrencyContainer() {
  const {
    data,
    loading,
    loadCurrencies,
    addCurrency,
    editCurrency,
    deleteCurrency,
  } = useCurrency();

  const [openAdd, setOpenAdd] = useState(false);
  const [editing, setEditing] = useState(null);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const userId =
    localStorage.getItem("user_id") || "69579c6190a653b640e65639";

  useEffect(() => {
    loadCurrencies();
  }, []);

  return (
    <>
      <div className="mb-4 flex justify-end">
        <button
          className="rounded bg-blue-600 px-4 py-2 text-white"
          onClick={() => setOpenAdd(true)}
        >
          + Add Currency
        </button>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}

      <CurrencyTable
        data={data}
        loading={loading}
        onEdit={setEditing}
        onDelete={async (row) => {
          try {
            await deleteCurrency(row._id, {
              is_deleted: true,
              deleted_by: userId,
            });
            setAlert({
              type: "success",
              message: "Currency deleted successfully",
            });
            loadCurrencies();
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Something went wrong while deleting currency",
            });
          }
        }}
      />

      <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
        <CurrencyForm
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload) => {
            try {
              await addCurrency({
                ...payload,
                created_by: userId,
              });
              setAlert({
                type: "success",
                message: "Currency created successfully",
              });
              setOpenAdd(false);
              loadCurrencies();
            } catch (error) {
              setAlert({
                type: "error",
                message:
                  error.response?.data?.message ||
                  "Something went wrong while creating currency",
              });
            }
          }}
        />
      </Modal>

      <Modal open={!!editing} onClose={() => setEditing(null)}>
        <CurrencyForm
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload) => {
            try {
              await editCurrency(editing._id, {
                ...payload,
                updated_by: userId,
              });

              setAlert({
                type: "success",
                message: "Currency updated successfully",
              });

              setEditing(null);
              loadCurrencies();
            } catch (error) {
              setAlert({
                type: "error",
                message:
                  error.response?.data?.message ||
                  "Something went wrong while updating currency",
              });
            }
          }}
        />
      </Modal>
    </>
  );
}
